import { ReactNode, useReducer } from "react";

import { DispatchContext, initialState, reducer, State, StateContext } from "./reducer";

interface SidePanelsProviderProps {
    children: ReactNode;
    initialState?: Partial<State>;
}

export function SidePanelsProvider({ children, initialState: customInitialState }: SidePanelsProviderProps) {
    const effectiveInitialState: State = {
        ...initialState,
        ...customInitialState,
    };

    const [state, dispatch] = useReducer(reducer, effectiveInitialState);

    return (
        <StateContext.Provider value={state}>
            <DispatchContext.Provider value={dispatch}>{children}</DispatchContext.Provider>
        </StateContext.Provider>
    );
}
